<template>
  <div class="forgot">
    <h3 class="blank-header primary--text">Forgot Password</h3>
    <v-flex>
      <v-form
              ref="forgotForm"
              v-model="forgotValid"
              lazy-validation
              @keyup.native.enter="submit"
      >
        <v-alert
                v-if="message"
                :value="message.length"
                :type="message.type"
                class="mb-3"
        >
          <div v-html="message.message"></div>
        </v-alert>
        <v-text-field
                v-model="email"
                :rules="rules.emailRules"
                label="E-mail"
                required
        ></v-text-field>
        <v-btn color="primary" @click="submit">Send Reset Link</v-btn>
      </v-form>
    </v-flex>
    <v-footer color="none" fixed justify-center>
      <v-container justify-center>
        <v-flex class="xs12 sm6 lg4 mx-auto" justify-center>
          <v-layout>
            <router-link to="register" class="footer-link">Not Registered?</router-link>
            <v-spacer></v-spacer>
            <router-link to="login" class="footer-link">Already Registered?</router-link>
          </v-layout>
        </v-flex>
      </v-container>
    </v-footer>
    <!--
    <v-card-text>
      <v-btn color="primary" @click="submit">Send Reset Link</v-btn>
    </v-card-text>
    <v-card-text>Don't have an account?<br>
      Click <router-link to="register">here</router-link> to register</v-card-text>
      -->
  </div>
</template>

<script>

  import { mapState } from 'vuex'

  export default {
    data: () => ({
      forgotValid: true,
      email: '',
      rules: {
        emailRules: [
          v => !!v || 'E-mail is required',
          v => {
            if (v.length > 0) {
              const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
              return pattern.test(v) || 'Invalid e-mail.'
            }
            return false
          }
        ],
        required: value => !!value || 'Required.'
      }
    }),

    computed: {
      ...mapState({
        message: state => state.global.message
      })
    },
    methods: {
      submit() {
        if (!this.$refs.forgotForm.validate()) {
          return
        }
        this.$store.dispatch('auth/forgot',{email: this.email})
      }
    }
  }
</script>

<style scoped lang="scss">
  .forgot {
    width: 100%;
  }
</style>
